import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import AES from "@ali/aes-tracker";
var paintPoint = {},
    lcpPoint = null,
    paintCount = 0;

var savePaintTimings = function savePaintTimings(_ref) {
  var name = _ref.name,
      startTime = _ref.startTime;
  var pointMap = {
    "first-paint": "p1",
    "first-contentful-paint": "p2"
  };

  if (!pointMap[name]) {
    return;
  }

  paintPoint[pointMap[name]] = startTime;
  paintCount++; // 不支持LCP，等待FP和FPC都触发了，一起上报一条

  if (!window.LargestContentfulPaint && paintCount === 2) {
    sendPaintTimings();
  }
};

var sendPaintTimings = function sendPaintTimings() {
  lcpPoint && parseLCPTimings(lcpPoint);

  if (paintCount || lcpPoint) {
    // 有任意点即可上报
    AES.log("paint", paintPoint);
  }
};

var sendUserTimings = function sendUserTimings(_ref2) {
  var entryType = _ref2.entryType,
      name = _ref2.name,
      startTime = _ref2.startTime,
      duration = _ref2.duration;
  var point = {
    p1: startTime,
    p2: duration,
    p3: entryType,
    p4: name
  };
  AES.log("usertiming", point);
};

var sendElementTimings = function sendElementTimings(item) {
  var parseData = function parseData(value) {
    if (typeof value === "string" || typeof value === "number") {
      return value;
    } else if (typeof value === "object" && value instanceof HTMLElement) {
      return value.tagName;
    }
  };

  var elementMap = {
    startTime: "p1",
    // 目前只关注这一时间 = renderTime / loadTime
    identifier: "p2",
    // 使用elementtiming=x 指定的名字
    name: "p3",
    // "text-paint" / "image-paint"
    url: "p4",
    // 只有image元素有
    element: "p5",
    // 只存标签名
    naturalHeight: "p6",
    naturalWidth: "p7" // renderTime: "", // text
    // loadTime: "", // img
    // duration: "", // 都是0
    // id: "",
    // intersectionRect: "", // 位置和大小属性

  };
  var point = {};

  for (var key in elementMap) {
    if (item[key] !== undefined) {
      point[elementMap[key]] = parseData(item[key]); // 映射到pX上
    }
  }

  AES.log("elementtiming", point);
};

var sendResourceTimings = function sendResourceTimings() {
  var _window, _window$performance, _window2, _window2$performance;

  var sampling = AES.getConfig('plugin_perf_resourceTimingSampling') || 0.01; // 默认百分之一采样

  if (Math.random() >= sampling) return; // 不满足采样率，不上报
  // 兼容性判断

  if (typeof window.fetch !== 'function' || !((_window = window) !== null && _window !== void 0 && (_window$performance = _window.performance) !== null && _window$performance !== void 0 && _window$performance.getEntries) || !((_window2 = window) !== null && _window2 !== void 0 && (_window2$performance = _window2.performance) !== null && _window2$performance !== void 0 && _window2$performance.getEntriesByType)) return;
  var threshhold = AES.getConfig('plugin_perf_resourceTimingThreshhold') || 8000,
      // 默认大于8s上报
  timing = performance.getEntriesByType("navigation")[0] || window.performance.timing;

  if (timing) {
    var loadEventStart = timing.loadEventStart,
        fetchStart = timing.fetchStart;
    if (loadEventStart - fetchStart < threshhold) return; // 小于上报阙值，不上报  
  } // 获取timing，包括NavigationTiming、ResourceTiming、PaintTiming、EventTiming


  var resources = performance.getEntries();
  if (!resources || resources.length === 0) return;

  try {
    var url = 'https://aes.cn-wulanchabu.log.aliyuncs.com/logstores/aes-resourcetiming/track',
        pv_id = AES.getConfig('pv_id'),
        pid = AES.getConfig('pid'),
        data = {
      "__topic__": "resourcetiming",
      "__logs__": [{
        pid: pid,
        name: pv_id,
        resource: encodeURIComponent(_JSON$stringify(resources.slice(0, 200))) // 限制了最多200条

      }]
    };
    if (!pid || !pv_id) return;
    fetch(url, {
      method: 'POST',
      body: _JSON$stringify(data),
      headers: {
        'Content-Type': 'application/json',
        'x-log-apiversion': '0.6.0',
        'x-log-bodyrawsize': '1234'
      }
    });
  } catch (err) {}
}; // 保存最后一个点即可，解析的过程抽离出去，最后执行


var saveLCPTimings = function saveLCPTimings(item) {
  lcpPoint = item;
};

var parseLCPTimings = function parseLCPTimings(item) {
  var parseData = function parseData(value) {
    if (typeof value === "string" || typeof value === "number") {
      return value;
    } else if (typeof value === "object" && value instanceof HTMLElement) {
      return value.tagName;
    }
  };

  var lcpMap = {
    startTime: "p3",
    // 目前只关注这一时间 = renderTime / loadTime
    element: "p4",
    // 只存标签名
    url: "p5" // 只有image元素有

  };

  for (var key in lcpMap) {
    if (item[key] !== undefined) {
      paintPoint[lcpMap[key]] = parseData(item[key]); // 映射到pX上
    }
  }
};

export { savePaintTimings, saveLCPTimings, sendPaintTimings, sendElementTimings, sendUserTimings, sendResourceTimings };


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-perf@1.1.7@@ali/aes-tracker-plugin-perf/es/send.js
// module id = null
// module chunks = 